export * from './user-profile.component';



// WEBPACK FOOTER //
// ./src/app/components/user-profile/index.ts